import { Container } from 'react-bootstrap';

const Footer = () => {
  return (
    <footer className="bg-dark text-white mt-auto py-3">
      <Container className="text-center">
        <small>&copy; {new Date().getFullYear()} BPP2026. All rights reserved.</small>
      </Container>
    </footer>
  );
};

export default Footer;